export default __webpack_public_path__ + "static/media/back.c0a81f59.svg";